/**
 * ProgressBar.jsx
 * Labelled linear progress bar used on navigation, stopped, and returning phases.
 * Accepts a custom colour gradient so each phase can have its own bar colour.
 */
import React from "react";
import { Box, Stack, Typography, LinearProgress } from "@mui/material";
import PropTypes from "prop-types";
import { tokens } from "../../theme";

const ProgressBar = ({ value, color = tokens.accent, label = "Progress" }) => {
  if (value >= 100) return null;
  return (
    <Box>
      {/* Label row: description left, percentage right */}
      <Stack direction="row" justifyContent="space-between" mb={0.75}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: tokens.text2 }}>{label}</Typography>
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: tokens.text }}>{value}%</Typography>
      </Stack>

      {/* Coloured progress track */}
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: 8,
          borderRadius: 4,
          background: tokens.surface3,
          "& .MuiLinearProgress-bar": { background: color, borderRadius: 4 },
        }}
      />
    </Box>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number,
  color: PropTypes.string,
  label: PropTypes.string,
};

export default ProgressBar;
